import React from 'react'

import classnames from 'classnames'
// @ts-ignore
import FormField from 'shared/newFormElements'

import translate from '../translate'
import { isRequired } from '../../helpers'
import { FifthPageWrapper } from './styles'

const CField = ({ label, name, field, style }) => (
  <div
    className={classnames('client-form__fifth-page__comment', {
      'client-form__fifth-page__comment--invisible': !field,
    })}
    style={{ ...style }}
  >
    <div className="comment-label">{translate(label)}</div>
    <FormField type="textarea" name={name} required={isRequired(field)} maxLength={field && field.MaxLen} autoFocus />
  </div>
)

const FourthPage = ({ fields }) => (
  <FifthPageWrapper>
    {!!fields.CField1 && <CField label="lbl_cfield1" name="CField1" field={fields.CField1} style={{ zIndex: 4 }} />}
    {!!fields.CField2 && <CField label="lbl_cfield2" name="CField2" field={fields.CField2} style={{ zIndex: 3 }} />}
    {!!fields.CField3 && <CField label="lbl_cfield3" name="CField3" field={fields.CField3} style={{ zIndex: 2 }} />}
    {!!fields.CField4 && <CField label="lbl_cfield4" name="CField4" field={fields.CField4} style={{ zIndex: 1 }} />}
  </FifthPageWrapper>
)

export default FourthPage
